"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrField = exports.RangeField = exports.PhoneField = exports.NumberField = exports.MultiUploader = exports.MListField = exports.ListField = exports.FreeField = exports.DateField = exports.BooleanField = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _core = require("@material-ui/core");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _lodash = _interopRequireDefault(require("lodash"));
var _CustomSwitch = require("../components/CustomSwitch");
var _index = require("react-platform-components/dist/uploader/index");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var FreeField = function FreeField(_ref) {
  var _productSpecificity$s;
  var index = _ref.index,
    value = _ref.value,
    productSpecificity = _ref.productSpecificity,
    isMd = _ref.isMd;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext.setFieldValue;
  return /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "specificities[".concat(index, "].choice"),
    value: value,
    label: productSpecificity.specificity.name,
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    onChange: function onChange(event) {
      setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
    },
    required: productSpecificity.required,
    validate: productSpecificity.required ? (0, _formValidators.required)() : function () {},
    endAdornment: !_lodash.default.isEmpty(productSpecificity === null || productSpecificity === void 0 ? void 0 : (_productSpecificity$s = productSpecificity.specificity) === null || _productSpecificity$s === void 0 ? void 0 : _productSpecificity$s.description) && /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity.specificity.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  });
};
exports.FreeField = FreeField;
var DateField = function DateField(_ref2) {
  var _productSpecificity$s2;
  var index = _ref2.index,
    value = _ref2.value,
    productSpecificity = _ref2.productSpecificity,
    isMd = _ref2.isMd;
  return /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "specificities[".concat(index, "].choice"),
    value: value,
    label: productSpecificity.specificity.name,
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    type: "date",
    required: productSpecificity.required,
    validate: productSpecificity.required ? (0, _formValidators.required)() : function () {},
    endAdornment: !_lodash.default.isEmpty(productSpecificity === null || productSpecificity === void 0 ? void 0 : (_productSpecificity$s2 = productSpecificity.specificity) === null || _productSpecificity$s2 === void 0 ? void 0 : _productSpecificity$s2.description) && /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity.specificity.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))),
    InputLabelProps: {
      shrink: true
    }
  });
};
exports.DateField = DateField;
var StrField = function StrField(_ref3) {
  var _productSpecificity$s3;
  var index = _ref3.index,
    value = _ref3.value,
    productSpecificity = _ref3.productSpecificity,
    isMd = _ref3.isMd;
  var _useFormikContext2 = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext2.setFieldValue;
  return /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "specificities[".concat(index, "].choice"),
    value: value,
    label: productSpecificity.specificity.name,
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    onChange: function onChange(event) {
      setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
    },
    required: productSpecificity.required,
    validate: productSpecificity.required ? (0, _formValidators.required)() : function () {},
    endAdornment: !_lodash.default.isEmpty(productSpecificity === null || productSpecificity === void 0 ? void 0 : (_productSpecificity$s3 = productSpecificity.specificity) === null || _productSpecificity$s3 === void 0 ? void 0 : _productSpecificity$s3.description) && /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity.specificity.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  });
};
exports.StrField = StrField;
var ListField = function ListField(_ref4) {
  var _productSpecificity$s4, _productSpecificity$s5;
  var index = _ref4.index,
    value = _ref4.value,
    productSpecificity = _ref4.productSpecificity,
    isMd = _ref4.isMd;
  var _useFormikContext3 = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext3.setFieldValue;
  var choices = productSpecificity.specificity.choices || [];
  var inputvalue = choices.find(function (choice) {
    return choice.value === value;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, choices.length >= _config.MIN_ITEMS_TO_USE_AUTOCOMPLETE_INSTEAD_OF_SELECT ? /*#__PURE__*/_react.default.createElement(_formFields.Autocomplete, _extends({
    label: productSpecificity.specificity.name,
    name: "specificities[".concat(index, "].choice"),
    options: choices,
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    required: productSpecificity.required,
    renderOption: function renderOption(option) {
      return /*#__PURE__*/_react.default.createElement("span", null, option.value);
    },
    value: inputvalue,
    onChange: function onChange(event, value) {
      return setFieldValue("specificities[".concat(index, "].choice"), value === null || value === void 0 ? void 0 : value.value);
    },
    noOptionsText: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "There is no informations to show",
      defaultMessage: "There is no informations to show"
    }),
    validate: productSpecificity.required ? (0, _formValidators.required)() : function () {}
  }, productSpecificity !== null && productSpecificity !== void 0 && (_productSpecificity$s4 = productSpecificity.specificity) !== null && _productSpecificity$s4 !== void 0 && _productSpecificity$s4.description ? {
    endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity.specificity.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  } : null)) : /*#__PURE__*/_react.default.createElement(_formFields.Select, _extends({
    variant: "outlined",
    fullWidth: true,
    required: productSpecificity.required,
    label: productSpecificity.specificity.name,
    name: "specificities[".concat(index, "].choice"),
    margin: "normal",
    onChange: function onChange(event) {
      setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
    },
    value: value,
    validate: productSpecificity.required ? (0, _formValidators.required)() : function () {}
  }, productSpecificity !== null && productSpecificity !== void 0 && (_productSpecificity$s5 = productSpecificity.specificity) !== null && _productSpecificity$s5 !== void 0 && _productSpecificity$s5.description ? {
    endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity.specificity.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  } : null), choices && choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: choice.value,
      value: choice.value
    }, choice.label);
  })));
};
exports.ListField = ListField;
var MListField = function MListField(_ref5) {
  var _productSpecificity$s6;
  var index = _ref5.index,
    value = _ref5.value,
    productSpecificity = _ref5.productSpecificity,
    isMd = _ref5.isMd;
  var _useFormikContext4 = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext4.setFieldValue;
  var choices = _lodash.default.orderBy(productSpecificity.specificity.choices, ['label'], ['asc']);
  return /*#__PURE__*/_react.default.createElement(_formFields.Select, _extends({
    variant: "outlined",
    fullWidth: true,
    margin: "normal",
    required: productSpecificity.required,
    value: value || [],
    label: productSpecificity.specificity.name,
    name: "specificities[".concat(index, "].choice"),
    validate: productSpecificity.required ? (0, _formValidators.required)() : function () {},
    onChange: function onChange(event) {
      setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
    },
    renderValue: function renderValue(selectedValues) {
      return selectedValues.map(function (value) {
        var _choices$find;
        return choices === null || choices === void 0 ? void 0 : (_choices$find = choices.find(function (choice) {
          return choice.value === value;
        })) === null || _choices$find === void 0 ? void 0 : _choices$find.label;
      }).join(', ');
    },
    multiple: true
  }, productSpecificity !== null && productSpecificity !== void 0 && (_productSpecificity$s6 = productSpecificity.specificity) !== null && _productSpecificity$s6 !== void 0 && _productSpecificity$s6.description ? {
    endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity.specificity.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  } : null), choices && choices.map(function (_ref6) {
    var label = _ref6.label,
      val = _ref6.value;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: val,
      value: val
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: (value || []).includes(val)
    }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      primary: label
    }));
  }));
};
exports.MListField = MListField;
var NumberField = function NumberField(_ref7) {
  var _productSpecificity$s7, _productSpecificity$s8;
  var index = _ref7.index,
    value = _ref7.value,
    productSpecificity = _ref7.productSpecificity,
    isMd = _ref7.isMd;
  var _useFormikContext5 = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext5.setFieldValue;
  return /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "specificities[".concat(index, "].choice"),
    value: value,
    label: productSpecificity.specificity.name,
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    onChange: function onChange(event) {
      setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
    },
    required: productSpecificity.required,
    validate: productSpecificity.required ? (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.number)()]) : (0, _formValidators.validators)([(0, _formValidators.number)()]),
    endAdornment: !_lodash.default.isEmpty(productSpecificity === null || productSpecificity === void 0 ? void 0 : (_productSpecificity$s7 = productSpecificity.specificity) === null || _productSpecificity$s7 === void 0 ? void 0 : _productSpecificity$s7.description) && /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "end"
    }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveTouchDelay: isMd && 3000,
      enterTouchDelay: isMd && 10,
      title: productSpecificity === null || productSpecificity === void 0 ? void 0 : (_productSpecificity$s8 = productSpecificity.specificity) === null || _productSpecificity$s8 === void 0 ? void 0 : _productSpecificity$s8.description
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))
  });
};
exports.NumberField = NumberField;
var RangeField = function RangeField(_ref8) {
  var index = _ref8.index,
    value = _ref8.value,
    productSpecificity = _ref8.productSpecificity,
    isMd = _ref8.isMd;
  return /*#__PURE__*/_react.default.createElement(_formFields.RangeField, {
    name: "specificities.".concat(index, ".choice"),
    min: productSpecificity.specificity.min,
    max: productSpecificity.specificity.max,
    step: productSpecificity.specificity.step,
    label: productSpecificity.specificity.name,
    value: value
  });
};
exports.RangeField = RangeField;
var BooleanField = function BooleanField(_ref9) {
  var index = _ref9.index,
    value = _ref9.value,
    productSpecificity = _ref9.productSpecificity;
  var _useFormikContext6 = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext6.setFieldValue;
  return /*#__PURE__*/_react.default.createElement(_CustomSwitch.CustomSwitch, {
    name: "specificities[".concat(index, "].choice"),
    checked: value || false,
    handleChange: function handleChange(event) {
      setFieldValue("specificities.".concat(index, ".choice"), event.target.checked);
    },
    description: productSpecificity.specificity.description,
    label: productSpecificity.specificity.name
  });
};
exports.BooleanField = BooleanField;
var MultiUploader = function MultiUploader(_ref10) {
  var index = _ref10.index,
    value = _ref10.value,
    productSpecificity = _ref10.productSpecificity;
  var mimeTypes = _lodash.default.map(productSpecificity.specificity.accepted_files_formats, function (formatFile) {
    return formatFile.mimetype;
  }).toString();
  return /*#__PURE__*/_react.default.createElement(_formik.Field, {
    required: productSpecificity.required,
    validate: productSpecificity.required ? (0, _formValidators.validators)([(0, _formValidators.required)()]) : null,
    name: "specificities[".concat(index, "].choice"),
    label: productSpecificity.specificity.name,
    value: value,
    maxFiles: productSpecificity.specificity.max_number_of_files,
    maxSize: productSpecificity.specificity.max_size_per_file,
    acceptedFiles: mimeTypes,
    component: _index.renderMultiFilesFieldNew
  });
};
exports.MultiUploader = MultiUploader;
var PhoneField = function PhoneField(_ref11) {
  var index = _ref11.index,
    value = _ref11.value,
    productSpecificity = _ref11.productSpecificity,
    isMd = _ref11.isMd;
  return /*#__PURE__*/_react.default.createElement(_formFields.PhoneNumber, {
    name: "specificities[".concat(index, "].choice"),
    label: productSpecificity.specificity.name,
    variant: "outlined",
    margin: "normal",
    country: productSpecificity.specificity.default_country,
    disableAreaCodes: true,
    fullWidth: true,
    required: productSpecificity.required
  });
};
exports.PhoneField = PhoneField;